import { access as ACCESS } from '@driftt/traffic-control'

const PARTICIPANT = 'PARTICIPANT'
const SALESFORCE_PARTICIPANT = 'SALESFORCE_PARTICIPANT'
const SALESFORCE_OWNER_PARTICIPANT = 'SALESFORCE_OWNER_PARTICIPANT'
const ABM_PARTICIPANT = 'ABM_PARTICIPANT'
const LEANDATA_PARTICIPANT = 'LEANDATA_PARTICIPANT'
const EXECUTE_GROUP = 'EXECUTE_RULE_GROUP'
export const ACTION_TYPES = Object.freeze({
  PARTICIPANT,
  SALESFORCE_PARTICIPANT,
  SALESFORCE_OWNER_PARTICIPANT,
  ABM_PARTICIPANT,
  LEANDATA_PARTICIPANT,
  EXECUTE_GROUP,
})

export const DEFAULT_CONDITIONS = [[]]

const ADD_ONE = 'ADD_ONE'
const ADD_ALL = 'ADD_ALL'
export const ADD_TYPES = Object.freeze({
  ADD_ONE,
  ADD_ALL,
})

const GROUP = 'GROUP'
const TEAM = 'TEAM'
export const USER_GROUP_TYPES = Object.freeze({
  GROUP,
  TEAM,
})

export const USER_GROUP_TYPE_OPTIONS = [
  {
    label: 'To a Team',
    value: USER_GROUP_TYPES.TEAM,
    isDisabled: () =>
      !ACCESS.hasGates(['has_beta_team_view', 'premium_enterprise']),
  },
  {
    label: 'To one or more teammates',
    value: USER_GROUP_TYPES.GROUP,
    isDisabled: () => false,
  },
]

export const ADD_TYPE_OPTIONS = [
  {
    label: 'Only one teammate at a time (Round robin)',
    value: ADD_TYPES.ADD_ONE,
  },
  {
    label: 'All teammates in this group at the same time',
    value: ADD_TYPES.ADD_ALL,
  },
]

export const RULE_TYPE_OPTIONS = {
  DEFAULT: 'DEFAULT',
  TEST: 'TEST',
}

export const TEST_MODE_TEXT =
  'This routing rule will not route to anyone. Instead, you can inspect how routing would occur in your Routing Audit Log (RAL)'
